import { Injectable } from '@angular/core';

import { Order } from '../../common/models/order';
import { PaymentStatus } from '../../common/models/paymentStatus';
import { PaymentInformation } from '../models/paymentInfo';
import { User } from '../models/user';
import { ProductPriceList } from '../models/productPriceList';

@Injectable()
export class SessionManager {

    constructor() { }

    setShoppingCartData(order: Order) {
        localStorage.setItem('shopingCart', JSON.stringify(order));
    }

    getShoppingCartData(): any {

        return JSON.parse(localStorage.getItem('shopingCart'));
    }

    removeShoppingCartData() {
        localStorage.removeItem('shopingCart');
    }


    setPromoCode(promoCode: string) {
        localStorage.setItem('promoCode', promoCode);
    }

    getPromoCode() {
        return localStorage.getItem('promoCode');
    }
    
    clearPromoCode(){
        localStorage.removeItem('promoCode');
    }

    setProductListCode(productListCode: string) {
        localStorage.setItem('productListCode', productListCode);
    }

    getProductListCode() {
        return localStorage.getItem('productListCode');
    }


    setCurrentUser(currentUser: User) {
        localStorage.setItem('currentUser', JSON.stringify(currentUser));
    }

    getCurrentUser() {
        return JSON.parse(localStorage.getItem('currentUser'));
    }

    removeCurrentUser() {
        localStorage.removeItem('currentUser');
    }

    setPaymentStatus(paymentStatus: PaymentStatus) {
        localStorage.setItem('paymentStatus', JSON.stringify(paymentStatus));
    }

    getPaymentStatus(): any {
        return JSON.parse(localStorage.getItem('paymentStatus'));
    }

    setPaymentReceipt(paymentReceipt: PaymentInformation) {
        localStorage.setItem('receipt', JSON.stringify(paymentReceipt));
    }

    getPaymentReceipt(): any {
        return JSON.parse(localStorage.getItem('receipt'));
    }

    generateSessionID() {
        const guid = (this.S4() + this.S4() + '-' + this.S4() + '-4' + this.S4().substr(0, 3)
         + '-' + this.S4() + '-' + this.S4() + this.S4() + this.S4()).toLowerCase();
        localStorage.setItem('sessionID', guid);
    }

    S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }

    setUserDataForRecommendation(suggestionList: string[]) {
        localStorage.setItem('userDataForRecommendation', JSON.stringify(suggestionList));
    }

    getUserDataForRecommendation() {
        return JSON.parse(localStorage.getItem('userDataForRecommendation'));
    }

    

}



// WEBPACK FOOTER //
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/src/app/common/helpers/session-manager.ts